module.exports = "<ng2-slim-loading-bar></ng2-slim-loading-bar>\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 270
// module chunks = 4